module.exports = __webpack_public_path__ + "img/banner-1.70084dbd.jpg";